export enum DialBind {
    'Dial',
    'Bind',
}
